// What the lambda does, in order, and the second (from the request start) at
// which each step becomes the current one. The generation is a single call
// of about a minute, so the pending row's step list advances on this
// schedule — the last step holds until the response lands. Copy lives in
// contentModals:generateScript.steps.
export const GENERATION_STEPS = [
    { key: "content", at: 0 },
    { key: "section", at: 3 },
    { key: "context", at: 7 },
    { key: "writing", at: 12 },
    { key: "review", at: 42 },
];
